import clsx from 'clsx';

import { Content } from '@/lib';
import styles from './Quote.module.scss';
import { Row } from '../../Row';

export function Quote({ text, caption, alignment, fluid }: Content.WithFluid<Content.Quote>) {
  return (
    <Row mobileGrid className={clsx(styles.row, caption && styles.withCaption, fluid && styles.fluid)}>
      <figure className={clsx(styles.content, styles[alignment])}>
        <blockquote>
          <p className={clsx(styles.text, 'text text-bold')}>{text}</p>
        </blockquote>
        <figcaption className={clsx(styles.caption, 'text text-sm')}>{caption}</figcaption>
      </figure>
    </Row>
  );
}
